import { useCallback, useEffect, useState } from 'react';
import type { ChannelDTO } from '@astral/shared';
import { api, ApiClientError } from '../lib/api.js';

interface UseChannelsResult {
  channels: ChannelDTO[];
  loading: boolean;
  error: string | null;
  reload: () => void;
}

/** Fetch the shared "My Channels" list. */
export function useChannels(): UseChannelsResult {
  const [channels, setChannels] = useState<ChannelDTO[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .listChannels()
      .then((rows) => {
        if (!cancelled) setChannels(rows);
      })
      .catch((err: unknown) => {
        if (!cancelled) setError(err instanceof ApiClientError ? err.message : 'Failed to load');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [nonce]);

  const reload = useCallback(() => setNonce((n) => n + 1), []);
  return { channels, loading, error, reload };
}
